export { default as InformationCircleSolidIcon } from './InformationCircleSolidIcon';
